/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import { StyleSheet, css } from "aphrodite";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Dashboard from "../../../services/api/dashboard";

const styles = StyleSheet.create({
  card: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    marginTop: 16,
    width: "100%",
    overflow: "hidden",
    transition: "all 0.3s ease",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "16px 20px 12px 20px",
    borderBottom: "1px solid #f0f0f0",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: "#1a1a1a",
    margin: 0,
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: "#f8f9fa",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0px",
    backgroundColor: "#ffffff",
  },
  headerRow: {
    background: "#1a237e",
  },
  headerCell: {
    padding: "8px 12px",
    fontSize: 13,
    fontWeight: 600,
    color: "#fff",
    textAlign: "center",
    border: "1px solid #dde1e7",
    borderBottom: "1px solid #303f9f",
  },
  dataRow: {
    backgroundColor: "#ffffff",
    ":hover": {
      backgroundColor: "#f1f3f7",
    },
  },
  cell: {
    padding: "8px 12px",
    fontSize: 13,
    color: "#333",
    border: "1px solid #e5e7eb",
    borderTop: "none",
    textAlign: "center",
    fontWeight: 500,
  },
});

// function MembershipByDivision() {
//   const [divisionTotals, setDivisionTotals] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const response = await Dashboard.getMembershipByDivision();
//         // console.log("Full API Response:", response);

//         let apiData = null;
//         if (response?.data?.data) {
//           apiData = response.data.data;
//         } else if (Array.isArray(response?.data)) {
//           apiData = response.data;
//         } else if (Array.isArray(response)) {
//           apiData = response;
//         } else {
//           throw new Error("Unexpected response structure");
//         }

//         if (!Array.isArray(apiData)) {
//           throw new Error("API data is not an array");
//         }

//         // ✅ Group by division
//         const totals = apiData.reduce((acc, item) => {
//           if (!acc[item.division]) {
//             acc[item.division] = 0;
//           }
//           acc[item.division] += item.memberCount || 0;
//           return acc;
//         }, {});

//         // console.log("Division Totals:", totals);

//         setDivisionTotals(totals);
//       } catch (err) {
//         console.error("Error fetching membership by division:", err);
//         setError(err.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div style={{ color: "red" }}>{error}</div>;

//   const headers = Object.keys(divisionTotals);
//   const values = Object.values(divisionTotals);

//   return (
//     <div className={css(styles.card)}>
//       <div className={css(styles.header)}>
//         <h3 className={css(styles.title)}>Membership by Division</h3>
//         {/* <InfoOutlinedIcon fontSize="small" style={{ color: "#999" }} /> */}
//       </div>

//       <div className={css(styles.tableContainer)}>
//         <table className={css(styles.table)}>
//           <thead>
//             <tr className={css(styles.headerRow)}>
//               {headers.map((header) => (
//                 <th key={header} className={css(styles.headerCell)}>
//                   {header}
//                 </th>
//               ))}
//               <th className={css(styles.headerCell)}>TOTAL</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr className={css(styles.dataRow)}>
//               {values.map((value, index) => (
//                 <td key={index} className={css(styles.cell)}>
//                   {value}
//                 </td>
//               ))}
//               <td className={css(styles.cell)}>
//                 {values.reduce((a, b) => a + b, 0)}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default MembershipByDivision;

function MembershipByDivision() {
  const [divisionTotals, setDivisionTotals] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await Dashboard.getMembershipByDivision();

        let apiData = null;
        if (response?.data?.data) {
          apiData = response.data.data;
        } else if (Array.isArray(response?.data)) {
          apiData = response.data;
        } else if (Array.isArray(response)) {
          apiData = response;
        } else {
          throw new Error("Unexpected response structure");
        }

        if (!Array.isArray(apiData)) {
          throw new Error("API data is not an array");
        }

        const totals = apiData.reduce((acc, item) => {
          if (!acc[item.division]) {
            acc[item.division] = 0;
          }
          acc[item.division] += item.memberCount || 0;
          return acc;
        }, {});

        setDivisionTotals(totals);
      } catch (err) {
        console.error("Error fetching membership by division:", err);
        // setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  // ✅ Custom sorting order
  const sortOrder = ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"];

  const headers = Object.keys(divisionTotals).sort(
    (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b)
  );

  // Sorted values based on new header order
  const values = headers.map((key) => divisionTotals[key]);

  return (
    <div className={css(styles.card)}>
      <div className={css(styles.header)}>
        <h3 className={css(styles.title)}>Membership by Division</h3>
      </div>

      <div className={css(styles.tableContainer)}>
        <table className={css(styles.table)}>
          <thead>
            <tr className={css(styles.headerRow)}>
              {headers.map((header) => (
                <th key={header} className={css(styles.headerCell)}>
                  {header}
                </th>
              ))}
              <th className={css(styles.headerCell)}>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr className={css(styles.dataRow)}>
              {values.map((value, index) => (
                <td key={index} className={css(styles.cell)}>
                  {value}
                </td>
              ))}
              <td className={css(styles.cell)}>
                {values.reduce((a, b) => a + b, 0)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MembershipByDivision;
